import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";
import { StyledLabel } from "../../../common/components/InputLabel";

const CanineAndMolarInput = ({ register, error, helperText }) => {
  const items = [
    "Maintain",
    "Improve canine relationship only",
    "Improve canine & molar relationship up to 4mm",
    "Correction to Class 1",
  ];

  return (
    <React.Fragment>
      <Grid item xs={3} sx={{marginTop: 1}}>
        <StyledLabel error={error} id="canine-and-molar-label">
          Canine and Molar Class Correction
        </StyledLabel>
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </Grid>
      <Grid item xs={9}>
        <FormControl>
          <RadioGroup
            aria-labelledby="canine-and-molar-label"
            name="canineAndMolar"
          >
                {items.map((item) => (
                  <FormControlLabel
                    key={item}
                    value={item}
                    control={<Radio {...register("canineAndMolar")} />}
                    label={item}
                  />
                ))}
          </RadioGroup>
        </FormControl>
      </Grid>
    </React.Fragment>
  );
};

export default CanineAndMolarInput;
